import react from 'react';
import { Text, Image } from '@chakra-ui/react';
import logo from './assets/image/logo.png';
import { FaStore, FaTwitter,FaDiscord,FaEthereum } from "react-icons/fa";
import './new.css'
import image1 from './assets/image/123.png';


export function HeaderX () {
    return(
        <div>
            <center>
                {/* <Image
                    borderRadius='20px'
                    border="2px solid"
                    boxSize='150px'
                    mb="30px"
                    src={image1}
                /> */}
{/* 
            <Text
                fontSize="56px"
                color="white"
                fontWeight="800"
                mb="20px"
            >CutieCats Club</Text> */}


                <div className="iconZone">
                    <a href='https://twitter.com/officialxel0' target="_blank">
                        <FaTwitter color="white" fontSize="25px"/>
                    </a>
                    <a href='https://discord.com/invite/5jX2P5XjzJ' target="_blank">
                        <FaDiscord color="white" fontSize="25px"/>
                    </a>
                    <a href='https://optimistic.etherscan.io/address/0x1f9ca631ae0c4890f99b38634c969b7e4f8719f0' target="_blank">
                        <FaEthereum color="white" fontSize="25px"/>
                    </a>
                    <a href='https://qx.app/collection/frenchfries' target="_blank">
                        <FaStore color="white" fontSize="25px"/>
                    </a>
                </div>
            </center>
            


      
    </div>

    )

}